<script setup lang="ts">
import GaiaDeleteButton from '../base/GaiaDeleteButton.vue';
import GaiaText from '../base/GaiaText.vue';
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  /** Where it came from, e.g. "Kova AG — MSA · contract file". */
  source: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits<{ remove: [] }>();

const border = gaiaNeutral.borderCard;
const surface = gaiaNeutral.surface;
const tile = gaiaNeutral.surfaceTint;
const icon = gaiaNeutral.text;
</script>

<template>
  <!-- A document picked into the signature request (wizard step 2): file tile,
       name + source, the signing-file-type select in #actions (Signable
       document / Attachment — adapt SigningFileType via statusMaps), remove. -->
  <n-flex align="center" :size="12" :wrap="false" class="gaia-selected-doc-row">
    <n-flex inline align="center" justify="center" :size="0" :wrap="false" class="tile">
      <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        :stroke="icon"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M4 2.5h5l3 3v8H4z" />
        <path d="M9 2.5v3h3" />
      </svg>
    </n-flex>
    <n-flex vertical :size="2" :style="{ minWidth: 0, flex: 1 }">
      <gaia-text truncate size="dense" weight="semibold" tone="ink">
        {{ props.name }}
      </gaia-text>
      <gaia-text v-if="props.source" truncate size="meta" tone="subtle">
        {{ props.source }}
      </gaia-text>
    </n-flex>
    <slot name="actions" />
    <gaia-delete-button intent="remove" :subject="props.name" @click="emit('remove')" />
  </n-flex>
</template>

<style scoped>
.gaia-selected-doc-row {
  padding: 11px 13px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(surface);
}

/* A fixed rounded tile that centres the file glyph. */
.tile {
  width: 30px;
  height: 30px;
  flex: none;
  border-radius: 8px;
  background: v-bind(tile);
}
</style>
